module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/bicycle-1.webp";